import script from "./OpenOrderList.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenOrderList.vue?vue&type=script&setup=true&lang=js"

import "./OpenOrderList.vue?vue&type=style&index=0&id=61ba0a30&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61ba0a30"]])

export default __exports__